import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { moldDto } from "src/dtos/mold/moldDto";
import { getData } from "src/utils/axios/serverHelper";

const baseUrl = `${config.apiUrl}/mold`;

export const getMoldPopupList = async (searchText: string, moldType: string = '') => {
	const url = `${baseUrl}/modal`;
	return await getData<ResponseDto<moldDto[]>>(url, {
		params: { searchText, moldType }
	});
};
